import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { HibernationJob } from '@cast/types-cluster-autoscaler';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

type MutationPayload = {
  clusterId: string;
  hibernationJob: HibernationJob;
};

export const useCreateHibernationJobMutation = () => {
  const { currentOrganization } = useOrganizations();

  return useMutation({
    mutationFn: ({ clusterId, hibernationJob }: MutationPayload) => {
      return apiClient.clusterAutoscaler.createHibernationJob({
        organizationId: currentOrganization!.id,
        clusterId,
        hibernationJob,
      });
    },
  });
};
